import dayjs from "dayjs"

export const initialTaskFormState = {
  targetType: 'org',
  selectedEntity: null,
  taskCode: null,
  startDate: null, // set to dayjs() at runtime via RESET
  durationDays: 14,
  notes: '',
}

export const taskFormReducer = (state, action) => {
  switch (action.type) {
    case 'INIT_FROM_TASK': return action.payload
    case 'SET': return { ...state, [action.key]: action.value }
    case 'RESET': return { ...initialTaskFormState, startDate: dayjs() }
    default: return state
  }
}
